<template>
  <div class="v-container">
    <div class="tag-container">
      <span
        v-if="article.youtubeVideoId"
        class="tag is-danger">
        <span class="icon is-small">
          <i class="fas fa-play"/>
        </span> Video
      </span>
    </div>
    <img :src="`${img}?q=60`">
    <div class="content tcont">
      <h4>Dernier article</h4>
      <p
        class="tcont"
        :title="article && article.title"><router-link :to="`article/${article && article.slug}`">{{ article && article.title }}</router-link></p>
    </div>
  </div>
</template>
<style scoped lang="scss">
.icon {
  margin-right: 4px !important;
  font-size: 10px;
}
.v-container {
  position: relative;
}
.tag-container {
  position: absolute;
  top: 10px;
  left: 10px;
}
.tcont {
  overflow: hidden;
}
.v-container {
  display: flex;
  img {
    object-fit: cover;
    width: 150px;
  }
}
.content {
  padding-left: 1em;
  h4 {
    font-weight: bold;
    color: #ef6c00;
    font-family: "Roboto Slab", serif;
    margin-bottom: 10px;
  }
}
</style>
<script>
import { getAsset } from "../../utils/contentful";
import { vuexApiGetStateMixin } from "vuex-api";

export default {
  mixins: [
    vuexApiGetStateMixin(
      ["articles", "resp", "data", "items", 0, "fields"],
      "article"
    ),
    vuexApiGetStateMixin(["articles", "resp", "data", "includes"], "includes")
  ],
  computed: {
    img: function() {
      return (
        this.includes &&
        this.article &&
        getAsset(this.includes, this.article.coverImg.sys.id).fields.file.url
      );
    }
  },
  name: "ArticlePreview"
};
</script>
